import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MenuService } from './menu.service';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { getUser } from '@app/store/user/user.reducer';
import { IUser } from '@app/store/user';
import { State } from '@app/store';
import { takeUntil } from 'rxjs/operators';
import { TitleBarComponent } from '../title-bar/title-bar.component';
import { FeatureFlagDirective } from '@shared/feature-flag/feature-flag.directive';

@Component({
  selector: 'app-aa-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TitleBarComponent,
    FeatureFlagDirective
  ]
})
export class NavBarComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store<State>);
  private readonly router = inject(Router);
  public readonly menuService = inject(MenuService);

  // we need to create set of API for CRUD to cp_settings table 
  // currently this flag is unused but once we create the API we can modify the name
  protected readonly todoFeatureFlag = 'FLAG_WEB_AMS_ADDRESS';

  currentActiveRoute = '/home';
  destroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.store.select(getUser).pipe(takeUntil(this.destroy$)).subscribe(user => this.loadUser(user));

    this.router.events
      .pipe(takeUntil(this.destroy$)).subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updateRoute(event.url);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadUser(user: IUser) {
    if (!user) { return; }
    this.menuService.setPrivileges(user);
  }

  updateRoute(route: string) {
    this.currentActiveRoute = route;
  }
}
